import { CmsProtectionStartSummaryPanelWhiteGoods } from '../../models/cms/cms-protection-start-summary-panel-white-goods.interface';

export const mockCmsProtectionStartSummaryPanelWhiteGoods: CmsProtectionStartSummaryPanelWhiteGoods =
  {
    protectionStartSummaryPanelBodyWhiteGoods:
      'If your appliance is in guarantee, cover will start once we have processed your application. If your appliance is out of guarantee, cover will start after a 30 day wait.',
    protectionStartSummaryPanelTitleWhiteGoods: 'Cover starting date',
  };
